// Navigation configuration per role
// path: route path; view: optional ?view= query param for module views

export const NAV_ITEMS = {
  ADMIN: [
    { id: 'overview', label: 'Overview', icon: 'BarChart2', path: '/dashboard' },
    {
      id: 'admin-group', label: 'Admin', icon: 'Shield', type: 'group',
      children: [
        { id: 'users', label: 'Users', icon: 'Users', path: '/admin', view: 'users' },
        { id: 'partners', label: 'Partners', icon: 'Briefcase', path: '/admin', view: 'partners' },
      ],
    },
    {
      id: 'devices-group', label: 'Device Management', icon: 'Cpu', type: 'group',
      children: [
        { id: 'point-types', label: 'Point Types', icon: 'Tag', path: '/devices-management', view: 'all-point-types' },
        { id: 'room-types', label: 'Room Types', icon: 'Grid', path: '/devices-management', view: 'all-room-types' },
        { id: 'device-types', label: 'Device Types', icon: 'Layers', path: '/devices-management', view: 'all-device-types' },
      ],
    },
    { id: 'account', label: 'Account', icon: 'User', path: '/account' },
  ],
  MANAGER: [
    { id: 'overview', label: 'Overview', icon: 'BarChart2', path: '/dashboard' },
    { id: 'users', label: 'Users', icon: 'Users', path: '/admin', view: 'users' },
    {
      id: 'devices-group', label: 'Device Management', icon: 'Cpu', type: 'group',
      children: [
        { id: 'projects', label: 'Projects', icon: 'Folder', path: '/devices-management', view: 'my-projects' },
        { id: 'points', label: 'Points', icon: 'MapPin', path: '/devices-management', view: 'all-points' },
        { id: 'sites', label: 'Sites', icon: 'Home', path: '/devices-management', view: 'all-sites' },
      ],
    },
    { id: 'account', label: 'Account', icon: 'User', path: '/account' },
  ],
};

export const getNavItems = (userType) => NAV_ITEMS[userType] || NAV_ITEMS.MANAGER;
